import { diffDays } from "../dates";

export const ENROLLMENT_STATUSES = [
  "link_sent",
  "filled",
  "active",
  "overdue",
  "suspended",
  "cancelled",
  "expired",
] as const;
export type EnrollmentStatus = (typeof ENROLLMENT_STATUSES)[number];

export const ENROLLMENT_STATUS_LABELS: Record<EnrollmentStatus, string> = {
  link_sent: "Link enviado",
  filled: "Aguardando pagamento",
  active: "Ativa",
  overdue: "Em atraso",
  suspended: "Suspensa",
  cancelled: "Cancelada",
  expired: "Expirada",
};

export type DunningState = "active" | "overdue" | "suspended" | "cancelled";

export interface DunningConfig {
  overdueDays: number;
  suspendDays: number;
  cancelDays: number;
}

/** Estado da régua pelo vencimento mais antigo em aberto (seção 8.5). */
export function dunningStateFor(
  oldestOpenDueDate: string | null,
  today: string,
  cfg: DunningConfig,
): DunningState {
  if (!oldestOpenDueDate) return "active";
  const late = diffDays(oldestOpenDueDate, today);
  if (late >= cfg.cancelDays) return "cancelled";
  if (late >= cfg.suspendDays) return "suspended";
  if (late >= cfg.overdueDays) return "overdue";
  return "active";
}

const ORDER: Record<DunningState, number> = { active: 0, overdue: 1, suspended: 2, cancelled: 3 };

/** A régua só avança; pagamento confirmado volta para active por outro caminho. */
export function shouldAdvance(current: DunningState, next: DunningState): boolean {
  return ORDER[next] > ORDER[current];
}

/** Garantia de 7 dias contados do primeiro pagamento. */
export function isWithinGuarantee(firstPaymentAt: Date, now: Date, days = 7): boolean {
  return now.getTime() - firstPaymentAt.getTime() <= days * 86_400_000;
}
